"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var SelectorList_1 = __importDefault(require("./SelectorList"));
var SidebarHeader_1 = __importDefault(require("./SidebarHeader"));
var SidebarOpener_1 = __importDefault(require("./SidebarOpener"));
var MobileHeader_1 = __importDefault(require("./MobileHeader"));
var UserMenu_1 = __importDefault(require("./UserMenu"));
var MenuItem_1 = __importDefault(require("./MenuItem"));
var LinkListMenu_1 = __importDefault(require("./LinkListMenu"));
var consts_1 = require("./consts");
var styles_1 = require("./styles");
var hooks_1 = require("./hooks");
var Typography_1 = __importDefault(require("../Typography"));
var Sidebar = function (_a) {
    var topItems = _a.topItems, bottomItems = _a.bottomItems, logoPath = _a.logoPath, user = _a.user, messages = _a.messages, skipToContentText = _a.skipToContentText;
    var _b = (0, hooks_1.useSidebarState)(), isSidebarOpen = _b.isSidebarOpen, setIsSidebarOpen = _b.setIsSidebarOpen, getInitialOpenSubmenu = _b.getInitialOpenSubmenu;
    var _c = (0, react_1.useState)(getInitialOpenSubmenu), expandedMenu = _c[0], setExpandedMenu = _c[1];
    var mainContentRef = (0, react_1.useRef)(null);
    // Find main content element
    (0, react_1.useEffect)(function () {
        mainContentRef.current = document.getElementById('main-container');
    }, []);
    var handleSkipToContent = function (e) {
        e.preventDefault();
        var mainContent = mainContentRef.current;
        if (mainContent) {
            // Find the first focusable element in main content
            var focusableElements = mainContent.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusableElements.length > 0) {
                focusableElements[0].focus();
            }
            else {
                // If no focusable elements, at least set focus to the container
                mainContent.setAttribute('tabIndex', '-1');
                mainContent.focus();
                mainContent.removeAttribute('tabIndex');
            }
        }
    };
    var setSidebarState = function (state) {
        localStorage.setItem('isSidebarOpen', JSON.stringify(state));
        setIsSidebarOpen(state);
        // custom event for outside react trees only
        var customEvent = new CustomEvent(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, { detail: { newState: state } });
        window.dispatchEvent(customEvent);
    };
    var handleOpenSidebar = function () { return setSidebarState(true); };
    var handleCloseSidebar = function () { return setSidebarState(false); };
    (0, react_1.useEffect)(function () {
        var mainContainer = document.getElementById('main-container');
        if (!mainContainer) {
            return;
        }
        if (isSidebarOpen) {
            mainContainer.classList.add('squashed');
        }
        else {
            mainContainer.classList.remove('squashed');
        }
    }, [isSidebarOpen]);
    var mapItems = function (_a) {
        var _b, _c, _d, _e, _f;
        var id = _a.id, label = _a.label, icon = _a.icon, to = _a.to, type = _a.type, selectorData = _a.selectorData, badgeNumber = _a.badgeNumber, onClick = _a.onClick, listData = _a.listData, testId = _a.testId, trailingIcon = _a.trailingIcon, isTargetBlank = _a.isTargetBlank;
        if (type === 'selector' && selectorData) {
            var activeItemId = selectorData.activeItemId, onChange = selectorData.onChange, subItems = selectorData.subItems;
            return ((0, jsx_runtime_1.jsx)(SelectorList_1.default, { id: (_b = id !== null && id !== void 0 ? id : to) !== null && _b !== void 0 ? _b : label, label: label, icon: icon, onChange: onChange, activeItemId: activeItemId, subItems: subItems, testId: testId, expandedMenu: expandedMenu, setExpandedMenu: setExpandedMenu, trailingIcon: trailingIcon, isIndependentExpanding: id === 'account-selector', isClosingOnClickOutside: id === 'account-selector' }, (_c = id !== null && id !== void 0 ? id : to) !== null && _c !== void 0 ? _c : label));
        }
        if (type === 'list' && listData) {
            var basePath = listData.basePath, items = listData.items, isBasePathLinkOff = listData.isBasePathLinkOff;
            return ((0, jsx_runtime_1.jsx)(LinkListMenu_1.default, { id: (_d = id !== null && id !== void 0 ? id : to) !== null && _d !== void 0 ? _d : label, label: label, icon: icon, basePath: basePath, items: items, testId: testId, expandedMenu: expandedMenu, setExpandedMenu: setExpandedMenu, trailingIcon: trailingIcon, isBasePathLinkOff: isBasePathLinkOff }, (_e = id !== null && id !== void 0 ? id : to) !== null && _e !== void 0 ? _e : label));
        }
        return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, { label: label, icon: icon, to: to, badgeNumber: badgeNumber, isTargetBlank: isTargetBlank, onClick: function () {
                if (onClick !== null && onClick !== void 0 ? onClick : to) {
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                    setExpandedMenu(null);
                    if (window.innerWidth < 768) {
                        localStorage.setItem('isSidebarOpen', JSON.stringify(false));
                        setIsSidebarOpen(false);
                        var customEvent = new CustomEvent(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, { detail: { newState: false } });
                        window.dispatchEvent(customEvent);
                    }
                }
            }, testId: testId, disabled: !to && !onClick, trailingIcon: trailingIcon }, (_f = id !== null && id !== void 0 ? id : to) !== null && _f !== void 0 ? _f : label));
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)(styles_1.SkipToContentLink, __assign({ id: "skip-to-content", href: "#main-container", onClick: handleSkipToContent, onKeyDown: function (e) {
                    if (e.key === 'Enter' || e.key === 'Space') {
                        handleSkipToContent(e);
                    }
                }, tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: skipToContentText !== null && skipToContentText !== void 0 ? skipToContentText : 'Skip to main content' }) })), (0, jsx_runtime_1.jsx)(MobileHeader_1.default, { logoPath: logoPath, setSidebarState: setSidebarState }), (0, jsx_runtime_1.jsx)(styles_1.Backdrop, { className: (0, classnames_1.default)({ visible: isSidebarOpen }) }), (0, jsx_runtime_1.jsx)(styles_1.SidebarContainer, __assign({ className: (0, classnames_1.default)({ opened: isSidebarOpen }) }, { children: (0, jsx_runtime_1.jsxs)(styles_1.Sizer, { children: [(0, jsx_runtime_1.jsx)(SidebarHeader_1.default, { handleCloseSidebar: handleCloseSidebar, logoPath: logoPath, messages: messages }), (0, jsx_runtime_1.jsx)(SidebarOpener_1.default, { handleOpenSidebar: handleOpenSidebar, messages: messages }), (0, jsx_runtime_1.jsxs)(styles_1.Scroller, { children: [topItems.map(mapItems), (0, jsx_runtime_1.jsx)("div", { style: { flex: 1 } }), (0, jsx_runtime_1.jsx)(styles_1.BottomHR, {}), (0, jsx_runtime_1.jsx)("div", { children: bottomItems.map(mapItems) })] }), (0, jsx_runtime_1.jsx)(styles_1.BottomHRforLoginUser, {}), (0, jsx_runtime_1.jsx)(UserMenu_1.default, __assign({}, user, { expandedMenu: expandedMenu, setExpandedMenu: setExpandedMenu }))] }) }))] }));
};
exports.default = Sidebar;
